'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import { Children, cloneElement, forwardRef, isValidElement } from 'react';
import { cn } from '../../utils/cn';
export const SidebarItem = forwardRef(({ children, className, dropdown = false, asChild, ...props }, ref) => {
    const childrenLength = Children.count(children);
    if (asChild && isValidElement(children)) {
        return cloneElement(children, {
            itemRef: ref,
            ...props,
        });
    }
    return (_jsx("li", { ...props, className: cn(dropdown
            ? ''
            : 'flex cursor-pointer items-center gap-3 rounded-md p-2.5 text-body-4 font-normal text-metal-400 transition-all duration-200 hover:bg-metal-50 hover:text-metal-900 dark:hover:bg-metal-800 dark:hover:text-white', childrenLength >= 2 ? '' : 'justify-center', className), ref: ref, children: children }));
});
SidebarItem.displayName = 'SidebarItem';
